<template>
  <div>
    <b-alert
      :show="dismissCountDown"
      dismissible
      fade
      variant="primary"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
      >
        {{allertMessage}}
    </b-alert>
    <preloader v-if="showPreloader"></preloader>
      <div class="container accident-report">
        <h1 class="text-center mb-1 sm">
          <base-button v-on:click="goHome" size='md' class="mt-1 back-button" type="primary">Back</base-button>
          Weekly Vehicle Inspection report
        </h1>
        <div class="panel panel-default">
          <div class="panel-body">
            <form @submit.prevent>
              <div class="card card-profile shadow mb-3">
                <div class="card-header">General info</div>
                <div class="card-body">
                  <div class="card-profile">
                    <div class="form-group">
                      <label >Vehicle Id</label>
                      <div class=" mb-3">
                        <input type="text" disabled :class="{'is-invalid': vErrors.first('vehicleID') }"  class="form-control" data-vv-validate-on="blur" v-model="inspectionData.vehicleID" name="vehicleID" >
                        <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                            <span>{{ vErrors.first('vehicleID') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label >VIS</label>
                      <div class=" mb-3">
                        <input type="text" disabled :class="{'is-invalid': vErrors.first('vis') }"  class="form-control" data-vv-validate-on="blur" v-model="inspectionData.vis" name="vis" >
                        <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                            <span>{{ vErrors.first('vis') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label >Division</label>
                      <div class=" mb-3">
                        <input type="text" disabled :class="{'is-invalid': vErrors.first('division') }"  class="form-control" data-vv-validate-on="blur" v-model="inspectionData.division" name="division" >
                        <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                            <span>{{ vErrors.first('division') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label >Inspected By</label>
                      <div class=" mb-3">
                        <input type="text" :class="{'is-invalid': vErrors.first('inspectedBy') }"  class="form-control" v-validate="'required'" data-vv-validate-on="blur" v-model="inspectionData.inspectedBy" name="inspectedBy" >
                        <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                            <span>{{ vErrors.first('inspectedBy') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label >Mileage</label>
                      <div class=" mb-3">
                        <input type="text" :class="{'is-invalid': vErrors.first('mileage') }"  class="form-control" data-vv-validate-on="blur" v-validate="'required|numeric'" v-model="inspectionData.mileage" name="mileage" >
                        <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                            <span>{{ vErrors.first('mileage') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group text-left">
                      <label >Audit Date</label>
                      <flat-pickr
                        class="form-control"
                        placeholder="Date"
                        :config="dateConfig"
                        v-model="inspectionData.auditDate">
                      </flat-pickr>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-profile shadow mb-3">
                <div class="card-header">Tire Pressure (psi)
                  <base-button class="pull-right" @click="actualPressureShow = !actualPressureShow" outline type="primary">Show/Hide</base-button>
                  <span class="underheader">Please write Actual Pressure</span>
                </div>
                <div v-show="actualPressureShow" class="card-body">
                  <div class="card-profile">
                    <div class="form-group">
                      <label >Driver Front</label>
                      <div class=" mb-3">
                        <input type="text" :class="{'is-invalid': vErrors.first('driverFrontTirePressure') }"  class="form-control" v-validate="'required|numeric'" data-vv-validate-on="blur" v-model="inspectionData.driverFrontTirePressure" name="driverFrontTirePressure" >
                        <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                            <span>{{ vErrors.first('driverFrontTirePressure') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label >Driver Rear</label>
                      <div class=" mb-3">
                        <input type="text" :class="{'is-invalid': vErrors.first('driverRearTirePressure') }"  class="form-control" v-validate="'required|numeric'" data-vv-validate-on="blur" v-model="inspectionData.driverRearTirePressure" name="driverRearTirePressure" >
                        <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                            <span>{{ vErrors.first('driverRearTirePressure') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label >Passenger Front</label>
                      <div class=" mb-3">
                        <input type="text" :class="{'is-invalid': vErrors.first('passengerFrontTirePressure') }"  class="form-control" v-validate="'required|numeric'" data-vv-validate-on="blur" v-model="inspectionData.passengerFrontTirePressure" name="passengerFrontTirePressure" >
                        <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                            <span>{{ vErrors.first('passengerFrontTirePressure') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label >Passenger Rear</label>
                      <div class=" mb-3">
                        <input type="text" :class="{'is-invalid': vErrors.first('passengerRearTirePressure') }"  class="form-control" v-validate="'required|numeric'" data-vv-validate-on="blur" v-model="inspectionData.passengerRearTirePressure" name="passengerRearTirePressure" >
                        <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                            <span>{{ vErrors.first('passengerRearTirePressure') }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-profile shadow mb-3">
                <div class="card-header">Brake functioning
                  <base-button class="pull-right" @click="brakeFunctioningShow = !brakeFunctioningShow" outline type="primary">Show/Hide</base-button>
                </div>
                <div v-show="brakeFunctioningShow" class="card-body">
                  <div class="card-profile">
                    <div class="form-group">
                      <label >Parking Brake</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('parkingBrake') }" name="parkingBrake" v-model="inspectionData.parkingBrake" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('parkingBrake')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('parkingBrake') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label >Foot Brake</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('footBrake') }" name="footBrake" v-model="inspectionData.footBrake" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('footBrake')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('footBrake') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-profile shadow mb-3">
                <div class="card-header">Gauges Functioning
                  <base-button class="pull-right" @click="gaugesFunctioningShow = !gaugesFunctioningShow" outline type="primary">Show/Hide</base-button>
                </div>
                <div v-show="gaugesFunctioningShow" class="card-body">
                  <div class="card-profile">
                    <div class="form-group">
                      <label >Fuel Gauge</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('fuelGauge') }" name="fuelGauge" v-model="inspectionData.fuelGauge" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('fuelGauge')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('fuelGauge') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label >Temperature</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('temperature') }" name="temperature" v-model="inspectionData.temperature" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('temperature')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('temperature') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Misc</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('misc') }" name="misc" v-model="inspectionData.misc" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('misc')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('misc') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-profile shadow mb-3">
                <div class="card-header">Safety Equipment in Vehicle
                  <base-button class="pull-right" @click="safetyEquipmentVehicleShow = !safetyEquipmentVehicleShow" outline type="primary">Show/Hide</base-button>
                </div>
                <div v-show="safetyEquipmentVehicleShow" class="card-body">
                  <div class="card-profile">
                    <div class="form-group">
                      <label>Flares</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('flares') }" name="flares" v-model="inspectionData.flares" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('flares')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('flares') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Fire Extinguisher</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('fireExtinguisher') }" name="fireExtinguisher" v-model="inspectionData.fireExtinguisher" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('fireExtinguisher')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('fireExtinguisher') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Jack and Tire Iron</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('jackTireIron') }" name="jackTireIron" v-model="inspectionData.jackTireIron" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('jackTireIron')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('jackTireIron') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Flashlight</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('flashlight') }" name="flashlight" v-model="inspectionData.flashlight" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('flashlight')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('flashlight') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Triangles</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('triangles') }" name="triangles" v-model="inspectionData.triangles" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('triangles')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('triangles') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-profile shadow mb-3">
                <div class="card-header">Body
                  <base-button class="pull-right" @click="bodyShow = !bodyShow" outline type="primary">Show/Hide</base-button>
                </div>
                <div v-show="bodyShow" class="card-body">
                  <div class="card-profile">
                    <div class="form-group">
                      <label>Cracks/Dings/Dents:</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('cracksDingsDents') }" name="cracksDingsDents" v-model="inspectionData.cracksDingsDents" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('cracksDingsDents')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('cracksDingsDents') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Rust:</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('rust') }" name="rust" v-model="inspectionData.rust" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('rust')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('rust') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-profile shadow mb-3">
                <div class="card-header">Documentation in Vehicle
                  <base-button class="pull-right" @click="documentationVehicleShow = !documentationVehicleShow" outline type="primary">Show/Hide</base-button>
                </div>
                <div v-show="documentationVehicleShow" class="card-body">
                  <div class="card-profile">
                    <div class="form-group">
                      <label>Insurance card:</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('insuranceCard') }" name="insuranceCard" v-model="inspectionData.insuranceCard" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('insuranceCard')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('insuranceCard') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Registration:</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('registration') }" name="registration" v-model="inspectionData.registration" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('registration')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('registration') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Accident Reporting Folder:</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('accidentReportingFolder') }" name="accidentReportingFolder" v-model="inspectionData.accidentReportingFolder" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('accidentReportingFolder')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('accidentReportingFolder') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>BBl_Card:</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('bblCard') }" name="bblCard" v-model="inspectionData.bblCard" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('bblCard')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('bblCard') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Explore Board Manual:</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('exploreBoardManual') }" name="exploreBoardManual" v-model="inspectionData.exploreBoardManual" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('exploreBoardManual')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('exploreBoardManual') }}</span>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="card card-profile shadow mb-3">
                <div class="card-header">Tires Worn/Need Changed
                  <base-button class="pull-right" @click="tiresWornNeedChangedShow = !tiresWornNeedChangedShow" outline type="primary">Show/Hide</base-button>
                </div>
                <div v-show="tiresWornNeedChangedShow" class="card-body">
                  <div class="card-profile">
                    <div class="form-group">
                      <label for="tireTread">Driver Front</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('driverFrontChanged') }" name="driverFrontChanged" v-model="inspectionData.driverFrontChanged" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('driverFrontChanged')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('driverFrontChanged') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="tireTread">Driver Rear</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('driverRearChanged') }" name="driverRearChanged" v-model="inspectionData.driverRearChanged" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('driverRearChanged')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('driverRearChanged') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="tireTread">Passenger Front</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('passengerFrontChanged') }" name="passengerFrontChanged" v-model="inspectionData.passengerFrontChanged" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('passengerFrontChanged')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('driverRearChanged') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="tireTread">Passenger Rear</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('passengerRearChanged') }" name="passengerRearChanged" v-model="inspectionData.passengerRearChanged" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('passengerRearChanged')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('passengerRearChanged') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-profile shadow mb-3">
                <div class="card-header">Supplies in Vehicle
                  <base-button class="pull-right" @click="suppliesVehicleShow = !suppliesVehicleShow" outline type="primary">Show/Hide</base-button>
                </div>
                <div v-show="suppliesVehicleShow" class="card-body">
                  <div class="card-profile">
                    <div class="form-group">
                      <label>First Aid Kit</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('firstaidkit') }" name="firstaidkit" v-model="inspectionData.firstaidkit" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('firstaidkit')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('firstaidkit') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Ice Scraper</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('icescraper') }" name="icescraper" v-model="inspectionData.icescraper" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('icescraper')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('icescraper') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Camera</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('camera') }" name="camera" v-model="inspectionData.camera" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('camera')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('camera') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Hand Truck</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('handtruck') }" name="handtruck" v-model="inspectionData.handtruck" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('handtruck')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('handtruck') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Shovel</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('shovel') }" name="shovel" v-model="inspectionData.shovel" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('shovel')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('shovel') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-profile shadow mb-3">
                <div class="card-header">Fluid at Acceptable Levels
                  <base-button class="pull-right" @click="fluidAcceptableLevelsShow = !fluidAcceptableLevelsShow" outline type="primary">Show/Hide</base-button>
                </div>
                <div v-show="fluidAcceptableLevelsShow" class="card-body">
                  <div class="card-profile">
                    <div class="form-group">
                      <label>Oil</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('oil') }" name="oil" v-model="inspectionData.oil" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('oil')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('oil') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Washer</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('washer') }" name="washer" v-model="inspectionData.washer" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('washer')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('washer') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Transmission</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('transmission') }" name="transmission" v-model="inspectionData.transmission" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('transmission')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('transmission') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Steering</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('steering') }" name="steering" v-model="inspectionData.steering" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('steering')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('steering') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-profile shadow mb-3">
                <div class="card-header">Lights/Horn Working
                  <base-button class="pull-right" @click="lightsHornWorkingShow = !lightsHornWorkingShow" outline type="primary">Show/Hide</base-button>
                </div>
                <div v-show="lightsHornWorkingShow" class="card-body">
                  <div class="card-profile">
                    <div class="form-group">
                      <label>Parking</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('parking') }" name="parking" v-model="inspectionData.parking" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('parking')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('parking') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Headlights</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('headlights') }" name="headlights" v-model="inspectionData.headlights" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('headlights')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('headlights') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Tail lights</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('tailLghts') }" name="tailLghts" v-model="inspectionData.tailLghts" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('tailLghts')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('tailLghts') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Flashers</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('flashers') }" name="flashers" v-model="inspectionData.flashers" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('flashers')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('flashers') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Interior</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('interior') }" name="interior" v-model="inspectionData.interior" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('interior')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('interior') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Turn signals</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('turnSignals') }" name="turnSignals" v-model="inspectionData.turnSignals" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('turnSignals')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('turnSignals') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Horn</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('horn') }" name="horn" v-model="inspectionData.horn" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('horn')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('horn') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-profile shadow mb-3">
                <div class="card-header">Appearance Acceptable
                  <base-button class="pull-right" @click="appearanceAcceptableShow = !appearanceAcceptableShow" outline type="primary">Show/Hide</base-button>
                </div>
                <div v-show="appearanceAcceptableShow" class="card-body">
                  <div class="card-profile">
                    <div class="form-group">
                      <label>Exterior(Wash)</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('exteriorWash') }" name="exteriorWash" v-model="inspectionData.exteriorWash" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('exteriorWash')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('exteriorWash') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Windows</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('windows') }" name="windows" v-model="inspectionData.windows" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('windows')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('windows') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Floors</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('floors') }" name="floors" v-model="inspectionData.floors" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('floors')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('floors') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Seats</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('seats') }" name="seats" v-model="inspectionData.seats" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('seats')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('seats') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Decals</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('decals') }" name="decals" v-model="inspectionData.decals" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('decals')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('decals') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-profile shadow mb-3">
                <div class="card-header">Tools
                  <base-button class="pull-right" @click="toolsShow = !toolsShow" outline type="primary">Show/Hide</base-button>
                </div>
                <div v-show="toolsShow" class="card-body">
                  <div class="card-profile">
                    <div class="form-group">
                      <label>Screw Drivers</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('screwDrivers') }" name="screwDrivers" v-model="inspectionData.screwDrivers" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('screwDrivers')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('screwDrivers') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Pliers</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('pliers') }" name="pliers" v-model="inspectionData.pliers" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('pliers')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('pliers') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Allen Key for EB</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('allenKey') }" name="allenKey" v-model="inspectionData.allenKey" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('allenKey')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('allenKey') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Micro Fiber Cloth</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('microFiberCloth') }" name="microFiberCloth" v-model="inspectionData.microFiberCloth" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('microFiberCloth')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('microFiberCloth') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Canned Air</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('cannedAir') }" name="cannedAir" v-model="inspectionData.cannedAir" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('cannedAir')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('cannedAir') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Screen Cleaner</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('screenCleaner') }" name="screenCleaner" v-model="inspectionData.screenCleaner" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('screenCleaner')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('screenCleaner') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Stand Cleaner</label>
                      <select class="form-control" :class="{'is-invalid': vErrors.first('standCleaner') }" name="standCleaner" v-model="inspectionData.standCleaner" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('standCleaner')">
                        <option value="" disabled></option>
                        <option value="true">Yes</option>
                        <option  value="false">No</option>
                      </select>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('standCleaner') }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Comments</label>
                      <textarea class="form-control"
                                v-model="inspectionData.comments"
                                name="serviceNotes"
                                rows="3">
                      </textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-profile shadow mb-3">
                <div class="card-body">
                  <div class="card-profile">
                    <div class="text-center">
                      <base-button type="primary" @click="vehicleInspectionSend" size='md' class="my-4">Submit</base-button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  </div>
</template>
<script>

import jobActionFormMixin from './../mixins/jobActionFormMixin'
import alertMixin from './../mixins/alertMixin'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import timestampMixin from './../mixins/timestampMixin'
import errorStatusMixin from './../mixins/errorStatusMixin'

export default {
  data () {
    return {
      dateConfig: {
        dateFormat: 'Y-m-d'
      },
      actualPressureShow: true,
      brakeFunctioningShow: true,
      gaugesFunctioningShow: true,
      safetyEquipmentVehicleShow: true,
      documentationVehicleShow: true,
      bodyShow: true,
      tiresWornNeedChangedShow: true,
      suppliesVehicleShow: true,
      fluidAcceptableLevelsShow: true,
      lightsHornWorkingShow: true,
      appearanceAcceptableShow: true,
      toolsShow: true,
      showPreloader: false,
      inspectionData: {
        vehicleID: '',
        vis: '',
        division: '',
        inspectedBy: '',
        mileage: '',
        auditDate: this.$moment().format('YYYY-M-D'),
        driverFrontTirePressure: '',
        driverRearTirePressure: '',
        passengerFrontTirePressure: '',
        passengerRearTirePressure: '',
        parkingBrake: '',
        footBrake: '',
        fuelGauge: '',
        temperature: '',
        misc: '',
        flares: '',
        fireExtinguisher: '',
        jackTireIron: '',
        flashlight: '',
        triangles: '',
        cracksDingsDents: '',
        rust: '',
        insuranceCard: '',
        registration: '',
        accidentReportingFolder: '',
        bblCard: '',
        exploreBoardManual: '',
        driverFrontChanged: '',
        driverRearChanged: '',
        passengerFrontChanged: '',
        passengerRearChanged: '',
        firstaidkit: '',
        icescraper: '',
        camera: '',
        handtruck: '',
        shovel: '',
        oil: '',
        washer: '',
        transmission: '',
        steering: '',
        parking: '',
        headlights: '',
        tailLghts: '',
        flashers: '',
        interior: '',
        turnSignals: '',
        horn: '',
        exteriorWash: '',
        windows: '',
        floors: '',
        seats: '',
        decals: '',
        screwDrivers: '',
        pliers: '',
        allenKey: '',
        microFiberCloth: '',
        cannedAir: '',
        screenCleaner: '',
        standCleaner: '',
        comments: ''
      }
    }
  },
  mounted () {
    this.updateDriverPerconalInfo()
  },
  methods: {
    goHome () {
      this.$router.push('/')
    },
    updateDriverPerconalInfo (data) {
      this.inspectionData.division = this.$store.state.driver.division || ''
      this.inspectionData.vehicleID = this.$store.state.driver.vehicleId || ''
      this.inspectionData.vis = this.$store.state.driver.name || ''
    },
    vehicleInspectionSend () {
      this.$validator.validateAll()
        .then(result => {
          if (result) {
            let now = this.getCurrentTime()
            let dataObj = this.inspectionData
            dataObj.time = now
            this.showPreloader = true
            this.$store.dispatch('sendMonthlyAuditDriverInfo', dataObj)
              .then(response => {
                this.showPreloader = false
                this.showAlert(2, 'Monthly Vehicle Inspection report has been sent')
                this.$router.push({ name: 'home' })
                console.log('Monthly Vehicle Inspection report has been sent')
              }).catch(err => {
                this.showPreloader = false
                console.log(err)
                if (!this.errorStatusAvaible(err) && this.isOnline) return this.showAlert(4, 'The request timeout exceeded. The data has been saved and uploaded later')
                if (this.isOnline) this.showAlert(5, err.response.data.result.message)
                if (this.isOffline) {
                  this.$router.push({ name: 'home' })
                }
              })
          }
        })
    }
  },
  components: {
    flatPickr
  },
  mixins: [jobActionFormMixin, alertMixin, timestampMixin, errorStatusMixin]
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .info-header {
    padding-top: 10px;
    margin-top: 25px;
    border-top: 1px solid #8898aa;
  }
  .info-header:first-child {
    margin-top: 0;
  }
  .underheader {
    display: block;
    font-size: 0.75rem;
  }
</style>
